module.exports = __webpack_public_path__ + "6a7540645d0ec9144a3cf8467eb9d8db.png";